
import { AppState } from "../../common/store/app-state/app-state-slice";

const emitVurbalizeEvent = (state: AppState, eventName: string, data: any) => {
  if (state?.merchIdHash === 'ee5674ec543c5d825834642141802d128b48dabcd776309d1bd069aa391e577b') {
  }

  if (vurbalize?.emit) {
    vurbalize.emit(eventName, data);
  }
};

export default emitVurbalizeEvent;
